<template>
  <!-- eslint-disable max-len -->
  <div>
    <LayoutContent v-if="loading">
      <Loader size="large" />
    </LayoutContent>
    <LayoutContent v-else>
      <LayoutContent
        inner
        padding
      >
        <div class="box-info">
          <h3 class="title">Download Plugin/API</h3>
          <p class="description">You need to download and choose our Plugin and API in order to test our payments, choose our module below.</p>
        </div>
      </LayoutContent>
      <div style="margin-top: 25px;">
        <svg
          class="svg"
          style="position: absolute;width: 0;height: 0;"
        >
          <clipPath
            id="tab-clip"
            clipPathUnits="objectBoundingBox"
          >
            <path d="
        M0.997,0.999 A0.076,0.541,0,0,1,
        0.921,0.457 L0.921,0.463 A0.076,0.542,0,0,0,
        0.846,0 H0.154 A0.076,0.542,0,0,0,
        0.079,0.463 L0.079,0.457 A0.076,0.541,0,0,1,
        0.003,0.999 H0 V1 H1 V0.999" />
          </clipPath>
        </svg>
        <div class="tab-container">
          <div
            class="tab-item"
            v-for="(data, idx) in listItem"
            v-bind:key="idx"
            :class="(idx == selectedTab)? 'active' : ''"
            @click="setSelectedTab(idx)"
          >{{ data.tab }}</div>
        </div>
        <LayoutContent
          inner
          padding
        >
          <div
            class="container-plugin"
            v-if="selectedTab == 0"
          >
            <div
              class="item-plugin"
              v-for="(item, index) in items.filter(obj => obj.type == 'PLUGIN')"
              :key="index"
            >
              <a
                :href="baseUrl+ '/' + item.file_download"
                target="_blank"
                download="download"
                class="btn"
                style="background-color:transparent"
              >
                <div class="item-detail">
                  <img :src="baseUrl +'/'+ item.image" />
                  <p>{{ item.version }}</p>
                </div>
              </a>
            </div>
          </div>
          <div
            class="box-info"
            v-else-if="selectedTab == 1"
          >
            <h3
              class="title"
              style="color: black"
            >API Documentation</h3>
            <p
              class="description"
              style="margin-bottom: 20px"
            >If you create your own website (without plugin), you can integrate using Bayarind API. API documentation is available at Bayarind.id.</p>
            <a
              v-for="(item, index) in items.filter(obj => obj.type == 'API')"
              :key="index"
              style="margin-top: 15px; color: black; font-size: 12px;"
              class="btn btn-primary-outline"
              variant="flat"
              size="mini"
              :href="baseUrl +'/'+ item.file_download"
              target="_blank"
              download="download"
            >See Documentation</a>
          </div>
          <div
            class="box-info"
            v-else-if="selectedTab == 2"
          >
            <h3
              class="title"
              style="color: black"
            >API One Pay Documentation</h3>
            <p
              class="description"
              style="margin-bottom: 20px"
            >If you create your own website (without plugin), you can integrate using Bayarind API. API documentation is available at Bayarind.id.</p>
            <a
              v-for="(item, index) in items.filter(obj => obj.type == 'ONEPAY')"
              :key="index"
              style="margin-top: 15px; color: black; font-size: 12px;"
              class="btn btn-primary-outline"
              variant="flat"
              size="mini"
              :href="baseUrl +'/'+ item.file_download"
              target="_blank"
              download="download"
            >See Documentation</a>
          </div>
          <div
            class="box-info"
            v-else-if="selectedTab == 3"
          >
            <h3
              class="title"
              style="color: black"
            >API Easy Invoice Documentation</h3>
            <p
              class="description"
              style="margin-bottom: 20px"
            >If you create your own website (without plugin), you can integrate using Bayarind API. API documentation is available at Bayarind.id.</p>
            <a
              v-for="(item, index) in items.filter(obj => obj.type == 'EASYINVOICE')"
              :key="index"
              style="margin-top: 15px; color: black; font-size: 12px;"
              class="btn btn-primary-outline"
              variant="flat"
              size="mini"
              :href="baseUrl +'/'+ item.file_download"
              target="_blank"
              download="download"
            >See Documentation</a>
          </div>
        </LayoutContent>

        <div class="btn-container">
          <Button
            @click="onSetStep(1)"
            variant="button"
            size="mini"
          >Previous</Button>
          <Button
            @click="onSetStep(3)"
            variant="button"
            size="mini"
          >Next</Button>
        </div>
      </div>
    </LayoutContent>

  </div>

</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator';
import LayoutContent from '@/components/LayoutContent.vue';
import Button from '@/components/Button.vue';
import Loader from '@/components/Loader.vue';
import api from '@/libs/api';

@Component({
  components: {
    LayoutContent,
    Button,
    Loader,
  },
})
export default class Step2 extends Vue {
  @Prop(Function) onSetStep;
  selectedTab = 0;
  loading = true;
  items = [];
  baseUrl = process.env.VUE_APP_API_URL;
  listItem = [
    {
      tab: 'PLUGIN',
    },
    {
      tab: 'Single Integration API',
    },
    {
      tab: 'Onepay API',
    },
    {
      tab: 'Easy Invoice API',
    },
  ];

  mounted() {
    this.getModul();
  }

  setSelectedTab(idx) {
    this.selectedTab = idx;
  }

  setNext() {
    this.onSetStep(3);
  }

  async getModul() {
    this.loading = true;
    const { data } = await api.get('/modul');
    this.loading = false;
    if (data.status) {
      this.items = data.data;
    }
  }
}
</script>

<style lang="scss" scoped>
.box-info .title {
  color: #288dc2;
  border-bottom: 1px solid #d5dbe2;
  padding-bottom: 7px;
  font-weight: bold;
}
.box-info .description {
  margin-top: 15px;
  font-size: small;
}
.tab-container {
  display: inline-flex;
  margin-left: 30px;
  margin-bottom: -1px;
}
.tab-item {
  background: $lightGrey;
  padding: 10px 0;
  width: 200px;
  text-align: center;
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
  font-weight: 600;
  color: darken(#8a95ae, 10%);
  clip-path: url(#tab-clip);
  font-size: small;
  cursor: pointer;
}
.container-plugin {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
}
.item-plugin {
  width: 33.33%;
  //padding: 20px;
}
.item-detail {
  margin: 10px;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.16);
  border-radius: 10px;
  height: 90px;
  position: relative;
  cursor: pointer;
}
.item-detail img {
  width: 70%;
  position: absolute;
  top: 50%;
  left: 50%;
  -moz-transform: translateX(-50%) translateY(-50%);
  -webkit-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
}
.item-detail p {
  text-align: center;
  // font-weight: bold;
  position: absolute;
  bottom: 0;
  left: 0;
  color: black;
  /* justify-content: center; */
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  margin-bottom: 8px;
  font-size: 14px;
}
.active {
  background: linear-gradient(90deg, #004387 0%, #156ba7 40%, #34a3d4 100%);
  color: white;
}
// .btn-container {
//   display: flex;
//   /* align-items: end; */
//   justify-content: flex-end;
//   margin: 15px 15px;
// }
.btn-primary-outline {
  background: transparent;
  border: 1px #0b8cd5 solid;
  padding: 6px 22px;
  border-radius: 15px;
  cursor: pointer;
  margin-right: 15px;
}

@media screen and (max-width: 768px) {
  .tab-item {
    border-top-left-radius: unset;
    border-top-right-radius: unset;
    -webkit-clip-path: unset;
    clip-path: unset;
    margin: 3px 0;
    width: 100%;
  }
}
</style>
